import { NotifyHelper } from "../../../helpers/toast";
import { eHeSoUuTienTKBActionsObj } from "../../action-types/category/IHeSoUuTienTKBActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const heSoUuTienTKBActions = {
    ...generateActions(eHeSoUuTienTKBActionsObj, "HE_SO_UU_TIEN_TKB"),
    ...generateActionForKey(eHeSoUuTienTKBActionsObj, "HE_SO_UU_TIEN_TKB", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eHeSoUuTienTKBActionsObj, "HE_SO_UU_TIEN_TKB", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
